// extracted by mini-css-extract-plugin
export var modal = "_gd-0";